export interface Invoice {
  invoice_reference?: string;
  invoice_status?: string;
  billing_unit?: string;

  invoice_date: string;
  invoice_due_date: string;

  net: number;
  outstanding_balance: number;
  paid_on?: string;

  sub_total: string;
  total_amount: number;
  total_tax: string;

  Description: string;

  amount_credited: string;
  company_id: string;
  company_title?: string;
}

export interface PagedInvoice {
  data: Invoice[];
  total_count: number;
  sub_total_sum: number;
  tax_sum: number;
  total_sum: number;
  credit_sum: number;
  outstanding_sum: number;
}

// billing units are xero organisations; the ETL stores them as konnekt/talexio/ITV
export const billingUnits = [
  { value: 'konnekt', label: 'Konnekt' },
  { value: 'talexio', label: 'Talexio' },
  { value: 'itv', label: 'ITV' },
];

export function billingUnitLabel(billingUnit?: string) {
  if (!billingUnit) return '';
  const match = billingUnits.find((u) => u.value === billingUnit.toLowerCase());
  return match?.label ?? billingUnit;
}
